var exports = {
  "qG": "pinnedNav__Dw4IiN",
  "yF": "divider__gQjcDV",
  "AI": "dividerCollapsible__q2EnFf",
};

module.exports = exports;
